import { useCallback, useMemo, useRef, useState } from 'react';

import type { GeneratedIntakeGroupHelp } from '../../types';

export function useGroupHelpPanel(groups: GeneratedIntakeGroupHelp[]) {
  const [selectedGroupId, setSelectedGroupId] = useState<string | null>(null);
  const openerRef = useRef<HTMLButtonElement | null>(null);

  const selectedGroup = useMemo(
    () => groups.find(group => group.group_id === selectedGroupId) ?? null,
    [groups, selectedGroupId],
  );

  const openGroup = useCallback((groupId: string, opener: HTMLButtonElement) => {
    openerRef.current = opener;
    setSelectedGroupId(groupId);
  }, []);

  const closeGroup = useCallback(() => {
    setSelectedGroupId(null);
    window.setTimeout(() => openerRef.current?.focus(), 0);
  }, []);

  return { selectedGroup, selectedGroupId, openGroup, closeGroup };
}
